// extracted by mini-css-extract-plugin
export default {"spacingP10":"uzuMojxPTbA4xY3D0x21"};